import { apiDelete, apiGet, apiPatch } from '../../../shared/api-client/index.js';
import type { AgentWidgetListItem } from '../agent-widgets.js';
import type { ViewSpec } from '../../../views/spec.js';

export function listAgentWidgets(): Promise<AgentWidgetListItem[]> {
  return apiGet<AgentWidgetListItem[]>('/agent-widgets');
}

export function deleteAgentWidget(id: string): Promise<void> {
  return apiDelete<void>(`/agent-widgets/${id}`);
}

export function updateAgentWidgetSpec(id: string, spec: ViewSpec): Promise<void> {
  return apiPatch<void, { spec: ViewSpec }>(`/agent-widgets/${id}`, { spec });
}
